import React, { useEffect, useState } from "react";
import { BackButton } from "../assets/Icons";
import { useNavigate } from "react-router-dom";
import { Country, State } from "country-state-city";
import { UiComponents } from "@simulanisindia/ui";
import {
  CATEGORY_TAGS_LIST,
  CREATE_CHANNEL_GROUP,
  FETCH_BUNDLE_LIST,
  FETCH_DIRECTORY_LIST,
} from "../apiClient/apiEndpoints";
import apiClient from "../apiClient";
import { v4 as uuidv4 } from "uuid";
import { SSO_URL } from "../env";
const { SimInputBar, DropdownSearch } = UiComponents;

const countriesName = Country.getAllCountries().map((e) => ({ value: e.name, label: e.name }));

const CreateGroup = () => {
  const navigate = useNavigate();
  const disable = false;
  const [errors, setErrors] = useState({});
  const [tagsList, setTagsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bundleList, setBundleList] = useState([]);

  const [groupDetails, setGroupDetails] = useState({
    logo: null,
    name: "",
    website: null,
    identifier: null,
    industry: [],
    address: {
      address1: null,
      address2: null,
      city: "",
      state: null,
      country: null,
      pincode: null,
    },
    bundle: "",
  });

  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    uid: "",
    phone: null,
    designation: null,
    password: "",
  });

  const getTagsList = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/1`);
      setTagsList(data.map((e) => ({ value: e.id, label: e.name })));
    } catch (error) {
      console.log(error);
    }
  };

  const handleReset = () => {
    setGroupDetails({
      logo: null,
      name: "",
      website: null,
      identifier: null,
      industry: [],
      address: {
        address1: null,
        address2: null,
        city: "",
        state: null,
        country: null,
        pincode: null,
      },
      bundle:""
    });
    setUserDetails({
      name: "",
      email: "",
      uid: "",
      phone: null,
      designation: null,
      password: "",
    });
    setErrors({});
    navigate('/dashboard/groups/list')
  };

  const validateDetails = () => {
    let tempErrors = {};

    if (!groupDetails.name.trim()) tempErrors.name = "Name is required.";
    if (groupDetails.industry.length === 0) tempErrors.industry = "Industry type is required.";
    if (!groupDetails.address.country) tempErrors.country = "Country is required.";
    if (!groupDetails.address.state) tempErrors.state = "State is required.";
    if (!groupDetails.address.city.trim()) tempErrors.city = "City is required.";
    if (!userDetails.name.trim()) tempErrors.userName = "User name is required.";
    if (!userDetails.email.trim() && !userDetails.uid.trim()) tempErrors.emailUid = "Either Email or UID is required.";
    if (!groupDetails.bundle.trim()) tempErrors.bundle = "Bundle type is required.";
    if (!userDetails.password.trim()) tempErrors.password = "Password is required.";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length > 0;
  };

  const handleSaveAddress = (field, value) => {
    setGroupDetails((pre) => ({ ...pre, address: { ...pre.address, [field]: value } }));
  };

  const handleGroupDetailFieldChange = (field, value) => {
    console.log(field, "this is field");
    console.log(value, "this is value");
    setGroupDetails((pre) => ({ ...pre, [field]: value }));
  };

  const handleCreateOrganization = async () => {
    if (loading) return;
    try {
      if (validateDetails()) return;

      setLoading(true);

      let bodyData = {
        group: {
          name: groupDetails.name.trim(),
          logo: groupDetails.logo,
          identifier: groupDetails.identifier,
          address: groupDetails.address,
          website: groupDetails.website,
          industryIds: groupDetails.industry.map((e) => e.value),
          uuid: uuidv4(),
          bundleId: groupDetails?.bundle,
        },
        user: {
          name: userDetails.name,
          email: userDetails.email || null,
          uid: userDetails.uid || null,
          phone: userDetails.phone,
          designation: userDetails.designation,
          password: userDetails.password
        },
      };
      await apiClient.post(`${SSO_URL}${CREATE_CHANNEL_GROUP}`, bodyData);
      handleReset();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBundleList = async () => {
    try {
      const response = await apiClient.get(`${SSO_URL}${FETCH_BUNDLE_LIST}`);
      const bundles = response?.map((e) => ({ value: e.uuid, label: e.type }));
      setBundleList(bundles);
    } catch (error) {
      console.log("Error in Fetching Bundles");
    }
  };

  useEffect(() => {
    getTagsList();
    fetchBundleList();
  }, []);

  return (
    <div className="container-fluid p-4 pt-2">
      <div className="row">
        <div className="col-md-6">
          <button className="backbtn cursor-pointer" onClick={() => navigate(-1)} title="Back">
            <BackButton /> Back
          </button>
        </div>
      </div>

      <div className="card mt-4 border-0">
        <div className="card-body p-4">
          <div className="colorborderchannel">
            <div className="row">
              <div className="col-md-6">
                <h4>Group Detail</h4>
              </div>
              <div className="col-md-6 d-flex gap-2 justify-content-end">
                <button className="btn btn-light" onClick={handleReset}>
                  Cancel
                </button>
                <button className="DefaultRedBtn" onClick={handleCreateOrganization}>
                  Save
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Name*"
                  placeholder="Enter Name"
                  value={groupDetails.name}
                  onChange={(e) => setGroupDetails((pre) => ({ ...pre, name: e.target.value }))}
                />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>

              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Company Website URL"
                  value={groupDetails.website}
                  onChange={(e) => setGroupDetails((pre) => ({ ...pre, website: e.target.value }))}
                  placeholder="Enter URL"
                />
              </div>

              <div className="col-md-3 mt-3">
                <SimInputBar
                  label="Identifier"
                  placeholder="Enter Identifier"
                  value={groupDetails.identifier}
                  onChange={(e) => setGroupDetails((pre) => ({ ...pre, identifier: e.target.value }))}
                />
              </div>

              <div className="col-md-3 mt-3">
                <DropdownSearch
                  label="Industry Type*"
                  selectProps={{
                    isMulti: true,
                    options: tagsList,
                    value: groupDetails.industry,
                    onChange: (e) => handleGroupDetailFieldChange("industry", e),
                  }}
                />
                {errors.industry && <p className="text-danger">{errors.industry}</p>}
              </div>

              {/* Address */}
              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Address Line 1"
                  placeholder="Enter Address 1"
                  value={groupDetails.address.address1}
                  onChange={(e) => handleSaveAddress("address1", e.target.value)}
                />
              </div>

              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Address Line 2"
                  placeholder="Enter Address 2"
                  value={groupDetails.address.address2}
                  onChange={(e) => handleSaveAddress("address2", e.target.value)}
                />
              </div>

              <div className="col-md-3 mt-3">
                <DropdownSearch
                  label="Country*"
                  selectProps={{
                    options: countriesName,
                    value: groupDetails.address.country
                      ? { value: groupDetails.address.country, label: groupDetails.address.country }
                      : null,
                    onChange: (e) => handleSaveAddress("country", e.value),
                  }}
                />
                {errors.country && <p className="text-danger">{errors.country}</p>}
              </div>

              <div className="col-md-3 mt-3">
                <DropdownSearch
                  label="State*"
                  selectProps={{
                    options: State.getStatesOfCountry(
                      Country.getAllCountries().find((c) => c.name === groupDetails.address.country)?.isoCode || ""
                    ).map((s) => ({ value: s.name, label: s.name })),
                    value: groupDetails.address.state
                      ? { value: groupDetails.address.state, label: groupDetails.address.state }
                      : null,
                    onChange: (e) => handleSaveAddress("state", e.value),
                  }}
                />
                {errors.state && <p className="text-danger">{errors.state}</p>}
              </div>

              <div className="col-md-3 mt-3">
                <SimInputBar
                  label="City*"
                  placeholder="Enter City"
                  value={groupDetails.address.city}
                  onChange={(e) => handleSaveAddress("city", e.target.value)}
                />
                {errors.city && <p className="text-danger">{errors.city}</p>}
              </div>

              <div className="col-md-3 mt-3">
                <SimInputBar
                  label="Pincode"
                  placeholder="Enter Pincode"
                  value={groupDetails.address.pincode}
                  onChange={(e) => handleSaveAddress("pincode", e.target.value)}
                />
              </div>

              <div className="col-md-3 mt-3">
                <DropdownSearch
                  label="Bundle Type*"
                  selectProps={{
                    options: bundleList,
                    value: bundleList.find((e) => e.value === groupDetails.bundle),
                    onChange: (e) => handleGroupDetailFieldChange("bundle", e?.value),
                  }}
                />
                {errors.bundle && <p className="text-danger">{errors.bundle}</p>}
              </div>
            </div>
          </div>

          <div className="colorborderchannel mt-4">
            <h4>User Details</h4>
            <div className="row">
              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Name*"
                  placeholder="Enter User Name"
                  value={userDetails.name}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, name: e.target.value }))}
                />
                {errors.userName && <p className="text-danger">{errors.userName}</p>}
              </div>

              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Email* (Either Email or UID is required)"
                  disabled={disable}
                  placeholder="Enter Email Address"
                  value={userDetails.email}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, email: e.target.value.replace(/\s/g, "") }))}
                />
              </div>

              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="Password"
                  disabled={disable}
                  placeholder="Enter password"
                  value={userDetails.password}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, password: e.target.value }))}
                />
                {errors.password && <p className="text-danger">{errors.password}</p>}
              </div>

              <div className="col-md-6 mt-3">
                <SimInputBar
                  label="UID* (Either Email or UID is required)"
                  disabled={disable}
                  placeholder="Enter UID"
                  value={userDetails.uid}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, uid: e.target.value.replace(/\s/g, "") }))}
                />
                {errors.emailUid && <p className="text-danger">{errors.emailUid}</p>}
              </div>

              <div className="col-md-3 mt-3">
                <SimInputBar
                  label="Phone"
                  placeholder="Enter Phone"
                  value={userDetails.phone}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, phone: e.target.value }))}
                />
              </div>

              <div className="col-md-3 mt-3">
                <SimInputBar
                  label="Designation"
                  placeholder="Enter Designation"
                  value={userDetails.designation}
                  onChange={(e) => setUserDetails((pre) => ({ ...pre, designation: e.target.value }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateGroup;
